module.exports = __webpack_public_path__ + "static/img/til42.87e175e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/til42.png
// module id = 1vg4
// module chunks = 1